/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const DocInfo16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            clipRule="evenodd"
            d="m10.28 1.413 3.314 3.374a1.403 1.403 0 0 1 .406.994V13.6c0 .371-.145.727-.403.99-.258.262-.607.41-.972.41h-9.25c-.365 0-.714-.148-.972-.41A1.413 1.413 0 0 1 2 13.6V2.4c0-.371.145-.727.403-.99.258-.262.607-.41.972-.41h5.93a1.354 1.354 0 0 1 .976.413Zm2.6 4.075.003.002a.401.401 0 0 1 .117.29v7.82a.413.413 0 0 1-.116.29.362.362 0 0 1-.259.11h-9.25a.363.363 0 0 1-.259-.11A.413.413 0 0 1 3 13.6V2.4c0-.112.044-.216.116-.29A.363.363 0 0 1 3.375 2h5.93a.354.354 0 0 1 .26.112l3.316 3.376Z"
        />
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 12a.5.5 0 0 1 0-1h.5V8H7a.5.5 0 1 1 0-1h1.5a.5.5 0 0 1 .488.611A.782.782 0 0 1 9 7.75V11h.5a.5.5 0 0 1 0 1H7Zm1-8a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
        />
    </AccessibleSVG>
);

export default DocInfo16;
